module.exports = __webpack_public_path__ + "img/client-bg.7ae1bcc1.jpg";